import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-maquinas-censo',
  templateUrl: './maquinas-censo.component.html',
  styleUrls: ['./maquinas-censo.component.scss']
})
export class MaquinasCensoComponent implements OnInit {

  
  constructor() { }
  
  optionsEstadoActual: Array<any> = [];

  ngOnInit() {

    this.optionsEstadoActual = [
      { value: "1", label: "Estado 1" },
      { value: "2", label: "Estado 2" },
      { value: "3", label: "Estado 3" },
    ];
  }

}
